import React from 'react'
import { Tooltip } from '@blueprintjs/core'
import { formatDate } from '../utils'

const InteractiveDatetime = ({ value }) => {
  if (!value) return null
  return <Tooltip content={formatDate(value, true)}>{formatDate(value)}</Tooltip>
}

// workaround for Jest https://github.com/airbnb/enzyme/issues/1875
export { InteractiveDatetime }
export default React.memo(InteractiveDatetime)
